import React from 'react'
import { Loading, Message } from '@workwhile/ui'
import { useSearchUsers } from 'queries/user'
import UserRecord from 'components/Users/UserRecord'

type OverviewTabProps = {
  userId: number
}

export const OverviewTab = ({ userId }: OverviewTabProps) => {
  const {
    data: users,
    isFetching,
    error,
    refetch,
  } = useSearchUsers({
    keyword: String(userId),
    enabled: true,
    staleTime: Infinity,
  })

  if (isFetching && !users) {
    return <Loading />
  }

  if (error) {
    return <Message variant="error">{error.message}</Message>
  }

  const user = users?.find((item) => Number(item.id) === userId) ?? users?.[0]

  if (!user) {
    return <Message variant="info">No user found for #{userId}.</Message>
  }

  return <UserRecord user={user} search={refetch} showPaymentSection={false} />
}
